/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const affectedSiblingSchema = z.object({
  currentCommitment: z.number(),
  membershipId: z.int(),
  newCommitment: z.number(),
  teamId: z.int(),
  teamName: z.string().nullish(),
});
